(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-scratch/assets/javascripts/components/top-bar/top-bar.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-scratch/assets/javascripts/components/top-bar/top-bar.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  useState,
  Fragment,
  useEffect,
  forwardRef
} = React;
const TopBarPage = svs.ticketgames.ticketScratch.components.topBar.TopBarPage;
const TopBarMenu = svs.ticketgames.ticketScratch.components.topBar.topBarMenu.TopBarMenu;
const log = new svs.core.log.Logger('components:TopBar');
setGlobal('svs.ticketgames.ticketScratch.components.topBar.TopBar', forwardRef((props, ref) => {
  const {
    onClose,
    size,
    ticketInfo,
    ticketDispatcher,
    gameHasSound,
    demo
  } = props;
  const {
    topBarRef,
    overlayRef
  } = ref;
  const [spelguides, setSpelguides] = useState([]);
  const [gameInfoOpen, setGameInfoOpen] = useState(false);
  const spelguidesExists = spelguides.length > 0;
  const {
    height,
    width
  } = size;
  const fetchGuides = _ref => {
    let {
      gameGuide
    } = _ref;
    const urls = [];
    const spelGuidesList = [];
    let i;
    for (i = 0; i < gameGuide.guides.length; i++) {
      urls.push(new svs.content.shared.ContentUrlBuilder("/id/".concat(gameGuide.guides[i].article)).build());
    }
    const url = "/multifetch?urls=".concat(encodeURIComponent(urls.join('|')));
    svs.core.jupiter.get(url, response => {
      if (!response.error) {
        for (i = 0; i < response.responses.length; i++) {
          if (response.responses[i].error) {
            log.error('Error fetching article', response.responses[i].error);
          } else if (!response.responses[i].result && !response.responses[i].result.length) {
            log.error('Spelguide article not found', response.responses[i]);
          } else if (response.responses[i].result[0]) {
            spelGuidesList.push(_objectSpread({
              tabName: gameGuide.guides[i].tabName,
              active: i === 0,
              order: i
            }, response.responses[i].result[0]));
          }
        }
        if (spelGuidesList.length === 1) {
          spelGuidesList[0].active = true;
        }
        setSpelguides(spelGuidesList);
      }
    });
  };
  useEffect(() => {
    var _ticketInfo$gameGuide;
    (ticketInfo === null || ticketInfo === void 0 || (_ticketInfo$gameGuide = ticketInfo.gameGuide) === null || _ticketInfo$gameGuide === void 0 ? void 0 : _ticketInfo$gameGuide.guides.length) > 0 && fetchGuides(ticketInfo);
    overlayRef.current.style.display = 'none';
  }, []);
  const setActiveTab = async (e, _ref2) => {
    let {
      tabName
    } = _ref2;
    e.preventDefault();
    setSpelguides(spelguides.map(spelGuide => {
      spelGuide.active = spelGuide.tabName === tabName;
      return spelGuide;
    }));
  };
  const toggleGameInfo = val => {
    setGameInfoOpen(val);
  };
  const toggleOverlay = open => {
    overlayRef.current.style.zIndex = open ? '1' : '-1';
    overlayRef.current.style.display = open ? 'inline-flex' : 'none';
  };
  return React.createElement(Fragment, null, React.createElement("div", {
    className: "ts-top-bar-menu-wrapper",
    ref: topBarRef
  }, React.createElement(TopBarMenu, {
    demo: demo,
    gameHasSound: gameHasSound,
    gameInfoOpen: gameInfoOpen,
    onClose: onClose,
    setActiveTab: setActiveTab,
    spelguides: spelguides,
    spelguidesExists: spelguidesExists,
    ticketDispatcher: ticketDispatcher,
    toggleGameInfo: toggleGameInfo,
    toggleOverlay: toggleOverlay
  })), React.createElement("div", {
    className: "ts-top-bar-overlay",
    ref: overlayRef,
    style: {
      height,
      width
    }
  }, spelguides.map((spelguide, i) => React.createElement(TopBarPage, {
    activeOrder: gameInfoOpen ? spelguides.find(sg => sg.active).order : -1,
    key: spelguide.tabName,
    order: i,
    spelguide: spelguide
  }))));
}), 'svs.ticketgames.ticketScratch.components.TopBar');

 })(window);